// components/Drawer.jsx


import arrow from "../../../src/icons/arrow.svg";

const Drawer = ({
  visible,
  onClose,
  title = "Back to Profile",
  children,
  onSubmit,
  className = "",
  style,
  hideFooter = false,
}) => {
  return (
    <div
      className={`fixed inset-0 z-50 flex justify-end bg-black bg-opacity-30 backdrop-blur-sm transition-opacity duration-300 ${
        visible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        className={`w-full sm:w-[70%] md:w-[60%] bg-white max-h-screen flex flex-col shadow-lg transform transition-transform duration-300 ease-in-out ${
          visible ? "translate-x-0" : "translate-x-full"
        } ${className}`}
        style={style}
      >
        {/* Header */}
        <div className="sticky top-0 z-10 flex justify-between items-center px-4 py-5 bg-white shadow-lg">
          <button onClick={onClose} className="flex items-center text-gray-700 font-medium">
            <img src={arrow} alt="Back" className="h-5 w-5 mr-2" />
            {title}
          </button>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold leading-none"
          >
            &times;
          </button>
        </div>

        
        <div className="flex-1 overflow-y-auto px-6 py-4">{children}</div>

    
        {!hideFooter && (
          <div className="sticky bottom-0 bg-white p-5 flex justify-center shadow-inner" id="sticky-footer">
            <button
              type="submit"
              onClick={onSubmit}
              className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-10 rounded-md text-sm"
            >
              Save
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Drawer;
